var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPortPoeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.4043L14.3333 7L10.6875 14.5957H16L7.33333 24L10.6667 16.4043H6Z",
    fill: "#373737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.4043L24.3333 7L20.6875 14.5957H26L17.3333 24L20.6667 16.4043H16Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPortPoeDark);
export default __webpack_public_path__ + "static/media/icn_port_poe++_Dark.de03f1e7436fe305de82c96ee0815ca0.svg";
export { ForwardRef as ReactComponent };